<template>
    <div class="alert-matchmaking">
        <div class="container-alert">
            <div class="image-alert">
                <!-- <img src="../../assets/clock.png" alt=""> -->
                <Clock></Clock>
            </div>
            <div class="text-alert">
                <span class="title">{{$t("components.Alerts.AlertMatchMaking.title[0]")}} {{minutes}} {{$t("components.Alerts.AlertMatchMaking.title[1]") }} </span>
                <span class="subtitle">{{$t("components.Alerts.AlertMatchMaking.subtitle[0]")}} <strong>{{$t("components.Alerts.AlertMatchMaking.subtitle[1]")}}</strong>{{$t("components.Alerts.AlertMatchMaking.subtitle[2]")}}<strong>{{$t("components.Alerts.AlertMatchMaking.subtitle[3]")}}</strong>!</span>
            </div>
            <div class="button-alert" @click="closeAlert()">
                <button-simple :textButton='$t("components.Alerts.AlertMatchMaking.textButton")'></button-simple>
            </div>
        </div>
    </div>    
</template>
<script>
import ButtonSimple from '../Buttons/ButtonSimple'
import Clock from "../Shared/CustomIcons/Dashboard/Schedule/Clock.vue"
export default {
    components : {
        ButtonSimple, Clock
    },
    props : {
        timeToInit : {
            type : String
        }
    },
    methods:{
        closeAlert(){
            this.$emit('closeAlert')
        }
    },
    computed: {
        minutes(){
            return this.timeToInit.substr(1,1)
        }
    }
}
</script>
<style lang="scss" scoped>
    .alert-matchmaking{
        width: 100%;
        height: 100vh;
        position: absolute;
        top: 0;
        background-color: #2F353A;
        z-index: 1000;

        .container-alert{
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            align-items: center;
            justify-content: center;

            .image-alert {
                background: #fff;
                width: 35%;
                padding: 7%;
                border-radius: 200px;
                margin: 32px auto;
                display: flex;
                align-items: center;
                justify-content: center;

                img{
                    height: 140px;
                    margin-top: 100px;
                }
                svg{
                    width: 125px;
                }
            }

            .text-alert{
                height: 30%;
                width: 90%;
                color: white;
                text-align: center;
                margin: 0 auto;
                display: flex;
                flex-direction: column;

                .title{
                    font-size: 20px;
                    font-weight: bold;
                }

                .subtitle{
                    font-size: 18px;
                    margin-top: 40px;
                }
            }
        }
        .button-alert{
            max-width: 300px;
            min-width: 200px;
            margin: 0 auto;
        }
    }

    @media only screen and( min-width: 750px){
        .alert-matchmaking{
            height: 100%;

            .container-alert{

                .image-alert{

                    height: 50%;
                }

                .text-alerT{

                    height: 25%;
                }
            }
        }
    }   
</style>
